import MenuSezioneArticolo from "./MenuSezioneArticolo";
import Menu from "./Menu";
import { MenuSezioneDeliverect } from "./MenuSezioneDeliverect";

export default class MenuSezione {
    id!: number;
    deliverectId?: string;
    nome!: string;
    ordinamento!: number;
    menuSezioneArticoloList!: MenuSezioneArticolo[];
    menuId?: number;
    menu!: Menu;
    menuSezioneDeliverect?: MenuSezioneDeliverect;
    externalId?: string;

    static fromJson(json: any) {
        let result = new MenuSezione();
        result.id = json.id;
        result.deliverectId = json.deliverectId;
        result.nome = json.nome;
        result.ordinamento = json.ordinamento;
        result.externalId = json.externalId;

        if (json.menuSezioneArticoloList) {
            result.menuSezioneArticoloList = json.menuSezioneArticoloList.map((menuSezioneArticolo: any) => MenuSezioneArticolo.fromJson(menuSezioneArticolo));
        }

        if (Array.isArray(json.menu)) {
            result.menu = json.menu.map((menu: any) => Menu.fromJson(menu));
        } else if (json.menu) {
            result.menu = Menu.fromJson(json.menu);
        }

        if (json.menuSezioneDeliverect) {
            result.menuSezioneDeliverect = MenuSezioneDeliverect.fromJson(json.menuSezioneDeliverect);
        }

        return result;
    }
}